<template>
  <canvas v-show="ready" id="palletHourChart" ref="palletHourChart" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  props: ["client_customer", "from_date", "to_date", "product"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Pallets",
          data: [],
          backgroundColor: "#0074d9",
          borderColor: "#0074d9",
          borderWidth: 1
          // datalabels: {
          //   formatter: function (value, context) {
          //     return new Intl.NumberFormat("es-CL").format(parseInt(value)) + " Kg";
          //   }
          // }
        }
      ]
    };
  },
  async mounted() {
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/arrivals/pallets_hours?client_customer=${this.client_customer}&product=${this.product}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      this.data[0].data = response.data.dataset;
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    let ctx = this.$refs.palletHourChart.getContext("2d");
    const palletHourChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: "right"
          },
          datalabels: {
            color: "#fff"
          },
          title: {
            display: true,
            text: "Horarios de entrega"
          },
          subtitle: {
            display: true,
            text: "Basado en la hora de registro"
          }
        },
        scales: {
          x: {
            ticks: {
              // Include a dollar sign in the ticks
              callback: function (value, index, ticks) {
                return this.getLabelForValue(value) + " Hrs";
              }
            }
          }
        }
      }
    });
  }
};
</script>

<style></style>
